import { DestroyRef, Directive, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { selectors } from '@twaice-fe/frontend/shared/store';
import { differenceInCalendarDays, isValid } from 'date-fns';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { combineLatest } from 'rxjs';

const { systemSelectors, configsSelectors } = selectors;

@Directive({
  selector: 'nz-date-picker[twaiceClampDateRange],nz-range-picker[twaiceClampDateRange]',
})
export class ClampDateRangeDirective implements OnInit {
  @Input() disableDateRangeClamp = false;
  @Input() useDataExplorerDate = false;

  constructor(
    private datePicker: NzDatePickerComponent,
    private destroy$: DestroyRef,
    private store: Store
  ) {}

  ngOnInit(): void {
    combineLatest([this.store.select(systemSelectors.getSelected)])
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe(([system]) => {
        if (this.disableDateRangeClamp) {
          this.datePicker.nzDisabledDate = () => false;
          return;
        }

        const installationDate = system?.dateFirstDataAvailable ?? system?.bessMetadata?.commercialOperationDate;
        const now = new Date();
        const todayUtcAsLocal = new Date(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours(),
          now.getUTCMinutes(),
          now.getUTCSeconds()
        );

        // clamp enabled dates
        this.datePicker.nzDisabledDate = (current: Date) => {
          const endCondition = this.useDataExplorerDate ? false : differenceInCalendarDays(current, todayUtcAsLocal) > 0;

          // if the installation date is valid we clamp the date to after the installation date
          if (isValid(new Date(installationDate))) {
            return endCondition || differenceInCalendarDays(current, new Date(installationDate)) < 0;
          }

          // else we just clamp it to the current date
          return endCondition;
        };
      });
  }
}
